import styled from "@emotion/styled";

export const BackorderPartsCellContent = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	"span:first-of-type": theme.project.typography.subtitle.subtitle2,
	"span:last-of-type": theme.project.typography.body.body2
}));
